export const yearlyStockTakeTranslations = {
  error: {
    title: {
      key: 'yearlyStockTakeTranslations.error.title',
      defaultValue: 'Oops! Something went wrong!',
    },
    subTitle: {
      key: 'yearlyStockTakeTranslations.error.subTitle',
      defaultValue: 'Something went wrong while fetching stock inventory count',
    },
  },
  noData: {
    title: {
      key: 'yearlyStockTakeTranslations.noData.title',
      defaultValue: 'Uh oh!!',
    },
    subtitle: {
      key: 'yearlyStockTakeTranslations.noData.subtitle',
      defaultValue: 'No Products counted at the moment',
    },
  },
  loading: {
    key: 'yearlyStockTakeTranslations.loading',
    defaultValue: 'Fetching Stock Inventory Count',
  },
  noteText: {
    key: 'yearlyStockTakeTranslations.noteText',
    defaultValue: 'Reminder: Be sure to check both the front and backstore for all garments before proceeding!',
  },
  bannerText: {
    key: 'yearlyStockTakeTranslations.bannerText',
    defaultValue: 'Stock inventory count will end by {{endDate}}',
  },
  articleBasedOnText: {
    key: 'yearlyStockTakeTranslations.articleBasedonText',
    defaultValue: ' Articles Based on',
  },
  numberOfArticlesText: {
    key: 'yearlyStockTakeTranslations.numberOfArticlesText',
    defaultValue: 'No. of Articles',
  },
  stockTable: {
    photo: {
      key: 'yearlyStockTakeTranslations.stockTable.photo',
      defaultValue: 'Photo',
    },
    status: {
      key: 'yearlyStockTakeTranslations.stockTable.status',
      defaultValue: 'Status',
    },
    articleNumber: {
      key: 'yearlyStockTakeTranslations.stockTable.articleNumber',
      defaultValue: 'Article Number',
    },
    product: {
      key: 'yearlyStockTakeTranslations.stockTable.product',
      defaultValue: 'Product',
    },
    productName: {
      key: 'yearlyStockTakeTranslations.stockTable.productName',
      defaultValue: 'Product Name',
    },
    productId: {
      key: 'yearlyStockTakeTranslations.stockTable.productId',
      defaultValue: 'Product ID',
    },
    department: {
      key: 'yearlyStockTakeTranslations.stockTable.department',
      defaultValue: 'Department',
    },
    departmentName: {
      key: 'yearlyStockTakeTranslations.stockTable.departmentName',
      defaultValue: 'Department Name',
    },
    departmentId: {
      key: 'yearlyStockTakeTranslations.stockTable.departmentId',
      defaultValue: 'Department ID',
    },
    index: {
      key: 'yearlyStockTakeTranslations.stockTable.index',
      defaultValue: 'Index',
    },
    subindex: {
      key: 'yearlyStockTakeTranslations.stockTable.subindex',
      defaultValue: 'Subindex',
    },
    action: {
      key: 'yearlyStockTakeTranslations.stockTable.action',
      defaultValue: 'Action',
    },
    noData: {
      title: {
        key: 'yearlyStockTakeTranslations.stockTable.noData.title',
        defaultValue: 'No Results Found!',
      },
      subtitle: {
        key: 'yearlyStockTakeTranslations.stockTable.noData.subtitle',
        defaultValue: 'No data present for selected filters. Please try again with different filters.',
      },
    },
  },
  singleAction: {
    foundItem: {
      button: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.button',
        defaultValue: 'Found it?',
      },
      modalButton: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.modalButton',
        defaultValue: 'Found',
      },
      modalTitle: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.modalTitle',
        defaultValue: 'Found item?',
      },
      modalSubtitle: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.modalSubtitle',
        defaultValue: 'Are you sure you want to mark this item as found?',
      },
      successText1: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.successText1',
        defaultValue: 'This item has been successfully marked as found!',
      },
      successText2: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.successText2',
        defaultValue: 'This item has been successfully marked as found and picked!',
      },
      errorText1: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.errorText1',
        defaultValue: 'This item could not be marked as found!',
      },
      errorText2: {
        key: 'yearlyStockTakeTranslations.singleAction.foundItem.errorText2',
        defaultValue: 'This item could not be marked as found and picked!',
      },
    },
    notFoundItem: {
      button: {
        key: 'yearlyStockTakeTranslations.singleAction.notFoundItem.button',
        defaultValue: 'Not Found?',
      },
      modalButton: {
        key: 'yearlyStockTakeTranslations.singleAction.notFoundItem.modalButton',
        defaultValue: 'Not Found',
      },
      modalTitle: {
        key: 'yearlyStockTakeTranslations.singleAction.notFoundItem.modalTitle',
        defaultValue: 'Item Not Found?',
      },
      modalSubtitle: {
        key: 'yearlyStockTakeTranslations.singleAction.notFoundItem.modalSubtitle',
        defaultValue: 'Are you sure you want to mark this item as not found?',
      },
      successText: {
        key: 'yearlyStockTakeTranslations.singleAction.notFoundItem.successText',
        defaultValue: 'This item has been successfully marked as not found!',
      },
      errorText: {
        key: 'yearlyStockTakeTranslations.singleAction.notFoundItem.errorText',
        defaultValue: 'This item could not be marked as not found!',
      },
    },
    checkboxes: {
      checkBackstore: {
        key: 'yearlyStockTakeTranslations.singleAction.checkboxes.checkBacktore',
        defaultValue: 'Did you check the backstore?',
      },
      checkFrontstore: {
        key: 'yearlyStockTakeTranslations.singleAction.checkboxes.checkFrontstore',
        defaultValue: 'Did you check the frontstore?',
      },
      pickItems: {
        key: 'yearlyStockTakeTranslations.singleAction.checkboxes.pickItems',
        defaultValue: 'Change status to picked',
      },
    },
  },
  bulkAction: {
    modalTitle: {
      key: 'yearlyStockTakeTranslations.singleAction.bulkAction.modalTitle',
      defaultValue: 'Confirm Pick/Unpick Action?',
    },
    successText: {
      key: 'yearlyStockTakeTranslations.singleAction.bulkAction.successText',
      defaultValue: 'Following items have been saved successfully!',
    },
  },
  applyChangesText: {
    key: 'yearlyStockTakeTranslations.applyChangesText',
    defaultValue: 'Apply Changes',
  },
  resetText: {
    key: 'yearlyStockTakeTranslations.resetText',
    defaultValue: 'Reset',
  },
  status: {
    pickStatus: {
      key: 'yearlyStockTakeTranslations.status.pickStatus',
      defaultValue: 'Pick',
    },
    pickedStatus: {
      key: 'yearlyStockTakeTranslations.status.pickedStatus',
      defaultValue: 'Picked',
    },
    notFoundStatus: {
      key: 'yearlyStockTakeTranslations.status.notFoundStatus',
      defaultValue: 'Not Found',
    },
  },
  pickUnpickAction: {
    pickItems: {
      key: 'yearlyStockTakeTranslations.pickAction.pickItems',
      defaultValue: 'Pick Items',
    },
    unpickItems: {
      key: 'yearlyStockTakeTranslations.pickAction.unpickItems',
      defaultValue: 'Unpick Items',
    },
    noItemSelected: {
      key: 'yearlyStockTakeTranslations.pickAction.noItemSelected',
      defaultValue: 'No items selected to pick/unpick',
    },
  },
};
